import { Component, OnInit, Input, Renderer2, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { pdpApiService } from 'src/app/services/pdp-api.service';
import { DialogModalComponent } from '../dialog-modal/dialog-modal.component';
import { count } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GoogleAnalyticsEventsService } from "../../services/google-analytics.service";

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.css']
})
export class OtpComponent implements OnInit {
  @Input() msisdn: string = '';
  @Input() msisdnType: string = '';
  @Input() isAutoLogin: boolean = false;
  @Output() cancelAction: EventEmitter<any> = new EventEmitter();

  currentlang: any;

  otp1: any = '';
  otp2: any = '';
  otp3: any = '';
  otp4: any = '';
  otp5: any = '';
  otp6: any = '';
  inputotp: string = '';
  validotp: boolean = false;
  validationMsg: string = '';

  showmin: number = 0;
  showsec: number = 0;
  sec: number = 0;
  isResendOtp: boolean = false;
  isLoading: boolean = false;
  isConsent: boolean = false
  consentType: number = 0;
  iohConsentChecked: boolean = false;
  otherConsentChecked: boolean = false;
  consent: any;

  signature: string = '';

  showToast: boolean = false;
  typeToast: number = 0;
  messageToast: string = '';
  stateDialog: string = '';
  showButton: boolean = false;
  modalRef: any;

  platform: any;

  constructor(
    public translate: TranslateService,
    private renderer: Renderer2,
    private pdpService: pdpApiService,
    private modalService: NgbModal,
    public googleAnalyticsService: GoogleAnalyticsEventsService,

  ) {
  }

  ngOnInit(): void {
    this.currentlang = localStorage.getItem('language');
    this.translate.use(this.currentlang);
    this.translate.setDefaultLang(this.currentlang);

    setTimeout(() => {
      this.platform = localStorage.getItem('platform');
    }, 100);

    this.startCountdown();
    this.checkAutoLogin();
  }

  onDigitInput(event: any, position: number) {
    const element1 = this.renderer.selectRootElement('#firstotp');
    const element2 = this.renderer.selectRootElement('#secondotp');
    const element3 = this.renderer.selectRootElement('#thirdotp');
    const element4 = this.renderer.selectRootElement('#fourthotp');
    const element5 = this.renderer.selectRootElement('#fifthotp');
    const element6 = this.renderer.selectRootElement('#sixthotp');

    if (this.otp1 !== '') {
      element2.focus();
    }
    if (this.otp2 !== '') {
      element3.focus();
    }
    if (this.otp3 !== '') {
      element4.focus();
    }
    if (this.otp4 !== '') {
      element5.focus();
    }
    if (this.otp5 !== '') {
      element6.focus();
    }

    this.checkotp();

    if (event.code == 'Backspace' || event.code == 'ArrowLeft') {
      switch (position) {
        case 1:
          if (event.code == 'Backspace') this.otp1 = ''
          this.inputotp = this.otp1 + this.otp2 + this.otp3 + this.otp4 + this.otp5 + this.otp6;
          break;
        case 2:
          element1.focus()
          if (event.code == 'Backspace') this.otp2 = ''
          this.inputotp = this.otp1 + this.otp2 + this.otp3 + this.otp4 + this.otp5 + this.otp6;
          break;
        case 3:
          element2.focus()
          if (event.code == 'Backspace') this.otp3 = ''
          this.inputotp = this.otp1 + this.otp2 + this.otp3 + this.otp4 + this.otp5 + this.otp6;
          break;
        case 4:
          element3.focus()
          if (event.code == 'Backspace') this.otp4 = ''
          this.inputotp = this.otp1 + this.otp2 + this.otp3 + this.otp4 + this.otp5 + this.otp6;
          break;
        case 5:
          element4.focus()
          if (event.code == 'Backspace') this.otp5 = ''
          this.inputotp = this.otp1 + this.otp2 + this.otp3 + this.otp4 + this.otp5 + this.otp6;
          break;
        case 6:
          element5.focus()
          if (event.code == 'Backspace') this.otp6 = ''
          this.inputotp = this.otp1 + this.otp2 + this.otp3 + this.otp4 + this.otp5 + this.otp6;
          break;
        default:
          break;
      }
    }
  }

  checkotp() {
    if (this.otp1 !== '' && this.otp2 !== '' && this.otp3 !== '' &&
      this.otp4 !== '' && this.otp5 !== '' && this.otp6 !== '') {
      this.validotp = true;
      this.inputotp =
        this.otp1 + this.otp2 + this.otp3 + this.otp4 + this.otp5 + this.otp6;
    } else {
      this.validotp = false;
    }
  }

  startCountdown() {
    let count = 300;
    let counter = count;
    this.showmin = counter / 60;
    this.showsec = Math.abs(Math.floor(counter / 60) * 60 - counter);

    let startDate = new Date();
    let startTimestamp = startDate.getTime();

    const interval = setInterval(() => {
      let endDate = new Date();
      let endTimestamp = endDate.getTime();
      let timeDiff = endTimestamp - startTimestamp;

      // console.log(Math.floor(timeDiff / 1000));

      if (counter < 1) {
        clearInterval(interval);
        counter = 0;
        this.isResendOtp = true;
      } else {
        counter = count - Math.floor(timeDiff / 1000);
        this.isResendOtp = false;
      }
      this.sec = counter;
      this.showmin = counter / 60;
      this.showsec = Math.abs(Math.floor(counter / 60) * 60 - counter);
    }, 1000);
  }

  resend() {
    if (this.isResendOtp) {
      this.isLoading = true;
      this.googleAnalyticsService.emitEvent("Resend OTP", "MSISDN", '62' + this.msisdn);
      this.pdpService.generateOtp('62' + this.msisdn, this.msisdnType).subscribe(res => {
        this.isLoading = false;
        if (res.data.OTPCommomServiceResp.ResponseCode === "00000") {
          this.isResendOtp = false;
          this.startCountdown();
          this.toogleToast(1);
        } else {
          this.toogleToast(0)
        }
      }, err => {
        this.isLoading = false;
        this.toogleToast(0)
      })
    }
  }

  verify() {
    if (this.inputotp.length === 6) {
      this.isLoading = true;
      this.googleAnalyticsService.emitEvent("Verify OTP", "MSISDN", '62' + this.msisdn);
      this.pdpService.validateOtp('62' + this.msisdn, this.msisdnType, this.inputotp).
        subscribe(resOTP => {
          const otp = resOTP.data.OTPCommomServiceResp;

          if (resOTP.status && otp.ResponseCode === "00000") {
            this.pdpService.fetchConsent('62' + this.msisdn, otp.OutParam2).
              subscribe(resConsent => {
                //const consent = resConsent.data.CustomerConsentServiceResp;

                if (resConsent.status && (resConsent.data.serviceStatus === 0 || resConsent.data.serviceStatus === 300)) {
                  this.consent = resConsent.data;
                  //testing consentStatus NC/PC/FC
                  //this.consent.consentStatus = 'FC'
                  // this.consent.consentList.forEach((el: any) => {
                  //   el.response_checkbox = el.response === 'N' ? true : false
                  // });

                  //function if for CONSENT WITHOUTRADIO
                  // if (consent.consentList?.length) {
                  //   //previously agree/disagree
                  //   this.consentType = consent.consentList[1].response === 'Y' ? 1 : 0;
                  // } else {
                  //   //not yet fill consent
                  //   this.consentType = 0
                  // }

                  //this.consentType = consent.consentList?.length ? 1 : 0;
                  // if (this.consentType) {
                  //   this.iohConsentChecked = consent.consentList[0].response === 'Y' ? true : false;
                  //   this.otherConsentChecked = consent.consentList[1].response === 'Y' ? true : false;
                  // } else {
                  //   this.iohConsentChecked = false;
                  //   this.otherConsentChecked = false;
                  // }
                  //if (this.iohConsentChecked && this.otherConsentChecked) {
                  //  this.isLoading = false;
                  // console.log('consent already exists')
                  //  this.stateDialog = 'update_success'

                  //  this.showButton = this.platform === 'indosat' ? false : true;
                  //} else {
                  this.signature = otp.OutParam2;
                  this.isLoading = false;
                  this.isConsent = true
                  this.stateDialog = ''
                  //}
                  // consentType: 0 => new, 1 => existing
                } else {
                  this.isLoading = false;
                  this.errorDialog()
                }
              }, err => {
                this.isLoading = false;
                this.isConsent = false
                this.errorDialog()
              })
          } else {
            this.isLoading = false;
            this.toogleToast(0)
          }
        }, err => {
          this.isLoading = false;
          this.toogleToast(0)
        })
    }
  }

  checkAutoLogin() {
    if (this.isAutoLogin) {
     // this.msisdn = '6289688056063';
      this.isLoading = true;
      this.pdpService.fetchConsentHash(this.msisdn).
        subscribe(resConsent => {
          if (resConsent.status && (resConsent.data.serviceStatus === 0 || resConsent.data.serviceStatus === 300)) {
            this.consent = resConsent.data;
            //testing consentStatus NC/PC/FC
            //this.consent.consentStatus = 'FC'
            // this.consent.consentList.forEach((el: any) => {
            //   el.response_checkbox = el.response === 'N' ? true : false
            // });

            //function if for CONSENT WITHOUTRADIO
            //if (consent.consentList?.length) {
            //previously agree/disagree
            // this.consentType = consent.consentList[1].response === 'Y' ? 1 : 0;
            //} else {
            //not yet fill consent
            //  this.consentType = 0
            //}

            // this.consentType = consent.consentList?.length ? 1 : 0;
            // if (this.consentType) {
            //   this.iohConsentChecked = consent.consentList[0].response === 'Y' ? true : false;
            //   this.otherConsentChecked = consent.consentList[1].response === 'Y' ? true : false;
            // } else {
            //   this.iohConsentChecked = false;
            //   this.otherConsentChecked = false;
            // }
            // check if consent is already given need to show the success page directly
            // if (this.iohConsentChecked && this.otherConsentChecked) {
            //   this.isLoading = false;
            //   // console.log('consent already exists')
            //   this.stateDialog = 'update_success'
            //   setTimeout(() => {
            //     this.showButton = this.platform === 'indosat' ? false : true;
            //   }, 100);
            // } else {
            this.isLoading = false;
            this.isConsent = true
            this.stateDialog = ''
            //}
            // consentType: 0 => new, 1 => existing
          } else {
            this.isLoading = false;
            this.errorDialog()
          }
        }, err => {
          this.isLoading = false;
          this.isConsent = false
          this.errorDialog()
        })
    }
  }

  cancel() {
    this.cancelAction.emit()
  }

  toogleToast(type: number) {
    type ? this.messageToast = 'otp_success' : this.messageToast = 'otp_fail'
    this.typeToast = type;
    this.showToast = false;
    setTimeout(() => {
      this.showToast = true;
    }, 100);
  }

  errorDialog() {
    this.modalRef = this.modalService.open(DialogModalComponent, {
      size: 'md',
      centered: true,
      // backdrop: 'static',
      windowClass: 'dialog-modal'
    });
    this.modalRef.componentInstance.dialogType = 'fetch_consent';
    this.modalRef.componentInstance.btnAction.subscribe((data: any) => {
      this.modalRef.close()
    });
  }

  btnAction() {
    // window.location.href = '';
    // window.open('', '_parent', '');
    // window.close();
    this.googleAnalyticsService.emitEvent("Got It Button", "platform", this.platform);
    if (this.platform.toLowerCase() === 'im3') {
      window.location.href = environment.im3HomePage
    } else {
      window.location.href = environment.bimaHomePage
    }
  }


}
